export default __webpack_public_path__ + "static/media/in-develop.be12064b.png";